// extracted by mini-css-extract-plugin
export default {"dataCenterSlider":"DataCenterSlider_dataCenterSlider__IKHwi","dataCenterSliderElements":"DataCenterSlider_dataCenterSliderElements__OVgUT"};